// extracted by mini-css-extract-plugin
export default {"required":"Input_required__d+M0N","inputHolder":"Input_inputHolder__dHDQF","inputItem":"Input_inputItem__9LWGZ","inputError":"Input_inputError__2VKJC"};